const steps = [
    {
        target: '#erd-diagram-container',
        title: "Entity Relationship Diagram",
        content: (
            <div>
                This diagram shows all resources in your application and how they relate to each other.
                Each box is a resource, and the lines between them represent lookup relationships.
            </div>
        ),
        disableBeacon: true,
    },
    {
        target: '#erd-zoom-controls',
        title: "Zoom Controls",
        content: (
            <div>
                Use the <strong>−</strong> and <strong>+</strong> buttons to zoom out and in.
                Click the percentage in the middle to fit the entire diagram back into view.
            </div>
        ),
    },
    {
        target: '#erd-download',
        title: "Download",
        content: (
            <div>
                Download the diagram as a <strong>PNG image</strong> for sharing, or as a
                <strong> Mermaid (.mmd)</strong> file to edit it in any Mermaid-compatible tool.
            </div>
        ),
    },
];

export default steps;
